export enum AlertType {
  CLINICAL = 'clinical',
  TECHNICAL = 'technical'
}
